// extracted by mini-css-extract-plugin
export default {"tiny-text":"xnB7+","tinyText":"xnB7+","tiny-link":"O5fuE","tinyLink":"O5fuE"};